<template>
  <div class="index-container">
    <!-- <snapshot /> -->
    <!-- <v-divider class="my-4" /> -->
    <calendar />
  </div>
</template>
<script>
// const Snapshot = () => import("@/components/home/Snapshot.vue");
const Calendar = () => import("@/components/home/Calendar.vue");

export default {
  data: () => ({}),
  components: {
    // Snapshot,
    Calendar
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
</style>
